import React from 'react';

const NoteScreen = () => {
  return (
    <main role="main">
      <article className="prose lg:prose-xl text-white">
        <h2 className="font-mono flex justify-center">
          <span className="rounded p-4 mb-4 md:mb-0 bg-yellow-500 text-purple-800">
            This is a concept website!
          </span>
        </h2>
        <p>
          The 'perfect' rich list would be a fully developed product that includes:
        </p>
        <ul>
          <li>
            <strong className="text-white underline">Realtime updates</strong> - powered
            by an API pulling in live stock prices of public holdings;
          </li>
          <li>
            <strong className="text-white underline">
              Comprehensive individual data
            </strong>{' '}
            - individual rich list entry pages featuring pie chart investment
            breakdowns, transparent valuations, historical wealth charts and
            tables, biographies, quotes, trivia;
          </li>
          <li>
            <strong className="text-white underline">Relational data</strong> -
            visualising partnerships/friendships between rich listers, as well
            as identifying trusted lieutenants, relevant board members,
            affiliates etc.;
          </li>
          <li>
            <strong className="text-white underline">Cusomized alerts</strong> - email/sms
            alerts on changes in investments, declared holdings, events detected
            by media monitoring;
          </li>
          <li>
            <strong className="text-white underline">Improved UI</strong> - especially
            around real estate investments photos and maps. On the backend an
            admin portal should make it easy for researchers to update entries;
          </li>
          <li>
            <strong className="text-white underline">External links</strong> - to easily
            access companies, invesments, boards and contact details;
          </li>
          <li>
            <strong className="text-white underline">Monetization</strong> - e.g.
            deploying a mobile app, introducing a subscription-based payment
            model, licencing the API;
          </li>
        </ul>
      </article>
      <article className="mt-8 prose lg:prose-xl text-white">
        <h2 className="font-mono mb-4">Notes on featured lists</h2>
        <ul>
          <li>
            The AFR Rich List was published under the Business Review Weekly
            (BRW) banner from 1984 to 2015. Originally it had 100 entries before
            expanding and branching out into additional lists (e.g. The Young
            Rich List);
          </li>
          <li>
            AFR has at times published a separate family list - this has not
            been published in hard copy or online since 2015;
          </li>
          <li>
            The Australian's Richest 250 is a relatively new list (only 2 years
            of data);
          </li>
          <li>
            The Forbes Australian Top 50 Rich List was previously the top 40
            Kiwis and Aussies before 2009;
          </li>
          <li>
            Notes about Forbes data on this site:
            <ul>
              <li>Kiwi entries from older lists have been excluded;</li>
              <li>
                A USD/AUD exchange rate from 31 March each year has been used
                for conversions (this is approximate to time of publishing each
                year);
              </li>
              <li>
                The 2021 data has been taken from the global billionaires list
                (42 Australian entries) at a Jan 2021 exchange rate;
              </li>
              <li>
                Forbes 2018 Data was taken from the global billionaries list (40
                Australian entries).
              </li>
            </ul>
          </li>
        </ul>
      </article>
    </main>
  );
};

export default NoteScreen;
